import React, {Fragment} from "react";
import {connect} from "react-redux";
import {updatePage} from "../../actions/page";
import {DEFAULT_PER_PAGE} from "../../config";
import {Col, Pagination, Row, Space, Table, Tag, Tooltip} from "antd";
import UndoOutlined from "@ant-design/icons/lib/icons/UndoOutlined";
import {displayErrors, normalizeEnum} from "../../libs/utils";
import {adminLoadTransactions} from "../../actions/billing";
import {Link} from "react-router-dom";
import {DeleteOutlined, EyeOutlined, FilterOutlined, PlusOutlined} from "@ant-design/icons";
import Button from "antd/es/button";
import {DateTimeFormat} from "../shared/DateTimeFormat";
import TransactionsTableFilters from "./TransactionsTableFilters";
import NewTransactionModal from "./NewTransactionModal";
import TransactionDetailModal from "./TransactionDetailModal";
import {MoneyField} from "../shared/MoneyField";

class TransactionsTable extends React.Component {
    state = {
        pagination: { current: 1, pageSize: DEFAULT_PER_PAGE, total: 0, showSizeChanger: true },
        transactions: [],
        loadingTransactions: true,
        showTransactionModal: false,
        activeTransaction: {},
        filters: [],
        showFiltersModal: false,
        showNewTransactionModal: false
    }

    componentDidMount() {
        this.props.updatePage('Transaction');
        this.adminLoadTransactions();
    }

    adminLoadTransactions(page = null, per_page = null) {
        if(page == null) {
            page = this.state.pagination.current;
            per_page = this.state.pagination.pageSize;
        }

        this.setState({ loadingTransactions: true });

        this.props.adminLoadTransactions(page, per_page, this.state.filters, (res) => {
            window.scrollTo(0, 0);

            this.setState({ transactions: res.data.data, loadingTransactions: false,
                pagination: { current: res.data.page, pageSize: res.data.per_page, total: res.data.total, showSizeChanger: true }});
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loadingTransactions: false });
                displayErrors(err.response.data);
            }
        });
    }

    changePage(pagination) {
        this.adminLoadTransactions(pagination.current, pagination.pageSize);
    }

    clearFilters() {
        this.setState({ filters: [] }, () => this.adminLoadTransactions());
    }

    setFilter(filter) {
        let filters = this.state.filters.filter(f => f.key !== filter.key);
        filters.push(filter);

        this.setState({ filters }, () => this.adminLoadTransactions());
    }

    removeFilter(item) {
        let filters = this.state.filters.filter(filter => filter.key !== item.key);
        this.setState({ filters }, () => this.adminLoadTransactions());
    }

    showFilters() {
        return this.state.filters.map((filter, i) => {
            let value;

            if (typeof filter.value === 'boolean') {
                if (filter.value) {
                    value = 'Yes';
                } else {
                    value = 'No';
                }
            } else {
                if (filter.visible !== null) {
                    value = filter.visible;
                } else {
                    value = normalizeEnum(filter.value);
                }
            }

            return <Tag key={i} closable onClose={() => this.removeFilter(filter)}>{filter.name}: {value}</Tag>;
        });
    }

    render() {
        const columns = [
            { title: 'ID', dataIndex: 'id' },
            { title: 'Owner', dataIndex: 'owner', render: (item) => {
                return <Link to={'/accounts/companies/' + item.guid}>{item.name}</Link>;
            }},
            { title: 'Created', dataIndex: 'date_created', render: (item) => <DateTimeFormat value={item} />},
            { title: 'Amount', dataIndex: 'amount', render: (item, record) => <MoneyField amount={item} currency={record.currency} />},
            { title: 'Method', align: 'center', dataIndex: 'payment_method_type', render: (item) => normalizeEnum(item)},
            { title: 'Transaction ID', dataIndex: 'transaction_id'},
            { title: '', align: 'right',
                render: (item, record) => <Button size='small' icon={<EyeOutlined />} onClick={() => this.setState({ showTransactionModal: true, activeTransaction: record })}>View</Button>},
        ];

        return(
            <Fragment>
                {this.showFilters()}
                <Row justify='space-between' style={{marginBottom: '10px'}}>
                    <Col>
                        <Space>
                            <Button type='text' size='small' icon={<PlusOutlined />} onClick={() => this.setState({ showNewTransactionModal: true })}>New Transaction</Button>
                            <Button type='text' size='small' icon={<FilterOutlined />} onClick={() => this.setState({ showFiltersModal: true })}>Filters</Button>
                            <Button type='text' size='small' disabled={this.state.filters.length === 0} onClick={() => this.clearFilters()} icon={<DeleteOutlined />}>Clear Filters</Button>
                        </Space>
                    </Col>
                    <Col>
                        <Space>
                            <Tooltip title='Reload' placement='left'>
                                <Button size='small' type='circle' loading={this.state.loading} disabled={this.state.loading} icon={<UndoOutlined />} onClick={() => this.adminLoadTransactions()} />
                            </Tooltip>
                            <Pagination onChange={(page, pageSize) => this.adminLoadTransactions(page, pageSize)} size='small' {...this.state.pagination} />
                        </Space>
                    </Col>
                </Row>
                <Table
                    columns={columns}
                    rowKey={(item) => item.guid}
                    dataSource={this.state.transactions}
                    loading={this.state.loadingTransactions}
                    pagination={false}
                    footer={() => <Row justify='space-between'>
                        <Col />
                        <Col><Pagination onChange={(page, pageSize) => this.adminLoadTransactions(page, pageSize)} size='small' {...this.state.pagination} /></Col>
                    </Row>}
                />

                <TransactionsTableFilters
                    showModal={this.state.showFiltersModal}
                    closeModal={() => this.setState({ showFiltersModal: false })}
                    onChange={(filter) => this.setFilter(filter) } />

                <NewTransactionModal
                    invoice={null}
                    currency={null}
                    reloadTransactions={() => this.adminLoadTransactions()}
                    showModal={this.state.showNewTransactionModal}
                    close={() => this.setState({ showNewTransactionModal: false })} />

                <TransactionDetailModal
                    showModal={this.state.showTransactionModal}
                    activeTransaction={this.state.activeTransaction}
                    close={() => this.setState({ showTransactionModal: false })} />
            </Fragment>
        )
    }
}

export default connect(null, { updatePage, adminLoadTransactions })(TransactionsTable);